<template>
  <div>
    <!-- <header></header> -->
    <!-- <div class="header">
      <div class="head_warp">
        <div class="head_title">心理健康教育平台</div>
      </div>
    </div> -->
    <!-- conotent -->
    <div
      id="gtco-header"
      class="gtco-cover gtco-cover-xs gtco-inner"
      role="banner"
      style="height: calc(100vh - 70px)"
    >
      <div class="gtco-container">
        <div class="row">
          <div class="col-md-24 col-md-offset-0 text-left">
            <div class="display-t">
              <div class="display-tc">
                <div class="row">
                  <div class="col-md-12 animate-box">
                    <h1 class="no-margin" style="padding-top:20px">四川蓝韵心理咨询服务有限公司</h1>
                    <div
                      style="color: #d3f1ed; font-size: 20px; "
                    >
                      在时代高速发展的今天，社会中的每一个人都承受的很大的压力，有的来自于情感，有的来源于房贷，
                      有的来源社交。我们有时候甚至自己都意识不到，自己的心理状态处于一种亚健康或者不健康的状态。
                      这时候，我们需要找心理咨询师以及了解心理学相关知识。
                    </div>
                    <div style="color: #d3f1ed; font-size: 20px">
                      心理健康教育平台App:一款可以进行自我测试、预约咨询、心理解压、心理学习的APP，让每一个人积极向上的面对每一天就是我们的宗旨，
                      心灵的健康让我们积极向上！
                    </div>
                    <div style="color: #d3f1ed; font-size: 20px">
                      心理健康教育平台APP:是四川蓝韵心理咨询服务有限公司致力于心理教育、心理测评、心理疏导、心理课程等领域研究以及心理应用科技相关软件开发。由应用心理学博士牵头的心理课题研究团队在计算机软件开发团队的配合下，取得了众多的心理运用成果:包括15项软件著作权，并申请了2项新型用专利以及1项发明专利。公司研发的产品在市场上赢得了广大师生、家长、老师、学校、教育局以及医院的广泛认可。
                    </div>
                    <div class="app-btns">
                      <div
                        class="btn-item"
                        id="android"
                        @click="androidDownload"
                      >
                        <img
                          src="/static/images/anzhuo.png"
                          alt=""
                          style="width: 28px; height: 28px"
                        />
                        安卓版下载
                      </div>
                      <div class="btn-item" id="ios" @click="iosDownload">
                        <img src="/static/images/pingguo.png" alt="" />
                        苹果版下载
                      </div>
                        <div class="btn-item" id="ios" @click="back">
                        返回首页
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-app"></div>
      <el-dialog
        title="安卓扫码下载"
        :visible.sync="isDowanload"
        width="500px"
      >
        <div>
          <img src="/static/images/appQrcode.png" style="display:block;margin:0 auto" alt="">
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDowanload = false">取 消</el-button>
          <el-button type="primary" @click="isDowanload = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div class="footer_line"></div>
    <!--footer-->
    <div class="footer">
      <p>
        <a target="_bank" href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          >四川蓝韵心理咨询服务有限公司</a
        >
      </p>
    </div>
  </div>
</template>
  <<script>
  export default {
    data(){
      return {
        isDowanload:false,
      }
    },
    methods:{
      iosDownload(){
        this.$message.info('开发中..')
      },
      androidDownload(){
        this.isDowanload = true
      },
      back(){
        this.$router.replace('/login')
      }
    }
  }
  </script>
     <style scoped>
#gtco-header {
  background: #3dcdbc;
  background: -moz-linear-gradient(left, #3dcdbc 0%, #33a1bd 100%);
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, #3dcdbc),
    color-stop(100%, #33a1bd)
  );
  background: -webkit-linear-gradient(left, #3dcdbc 0%, #33a1bd 100%);
  background: -o-linear-gradient(left, #3dcdbc 0%, #33a1bd 100%);
  background: -ms-linear-gradient(left, #3dcdbc 0%, #33a1bd 100%);
  background: linear-gradient(to right, #3dcdbc 0%, #33a1bd 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3dcdbc', endColorstr='#33a1bd', GradientType=1);
}

#gtco-header p {
  color: #d3f1ed;
  font-size: 20px;
  margin-bottom: 40px !important;
}

#gtco-header h1 {
  font-size: 50px;
  line-height: 1.2 !important;
  margin-bottom: 30px !important;
  color: #d3f1ed;
  font-weight: 100;
}

@media screen and (max-width: 768px) {
  #gtco-header h1 {
    line-height: 1.2 !important;
  }
}
.banner-app {
  position: absolute;
  bottom: 0%;
  right: 10%;
  width: 30%;
  height: 65%;
  z-index: 99;
  transform: rotate(45deg);
  background: #000;
  background: url(/static/images/banner-app.png) no-repeat;
  background-size: 80%;
  animation-name: beat;
  /*动画名称*/
  animation-duration: 1.2s;
  /*设置秒数*/
  animation-timing-function: linear;
  /*速度曲线*/
  animation-iteration-count: infinite;
  /*播放次数*/
  animation-direction: alternate;
  /*逆向播放*/
  /* animation-play-state: running; */
}

.app-btns {
  display: flex;
  align-items: center;
}

.app-btns .btn-item {
  margin-top: 20px;
  width: 200px;
  height: 50px;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  margin-right: 20px;
  cursor: pointer;
  text-indent: 0 !important;
}

.app-btns .btn-item img {
  width: 25px;
  height: 25px;
}

@keyframes beat {
  0% {
    bottom: 3%;
  }
  100% {
    bottom: 0%;
  }
}
</style>
<style scoped lang='less'>
.warp {
  width: 980px;
  margin: 0 auto;
}
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/header_bg.jpg);
  z-index: 99;
  position: relative;
}
.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}
.head_title {
  font-size: 24px;
}
.content .warp {
  background: url(/static/images/container_bg.png) repeat-y;
  padding: 0 4px 0 100px;
}
.back-head {
  padding-top: 60px;
  line-height: 100%;
}
.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}
.back-head p {
  margin: 15px 0 60px;
  font-size: 16px;
  color: #333;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #000;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #091d7c;
}

.next {
  width: 780px;
  text-align: center;
}
.next_btn {
  padding: 12px 50px;
}
.area_list {
  display: flex;
  width: 675px;
}
.class_warp {
  width: 675px;
  display: flex;
}
.radio_warp {
  margin: 20px 0;
}
.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}

.el-form-item {
  margin-bottom: 30px;
}

.rest_title {
  font-size: 20px;
  padding: 10px;
  height: 40px;
  line-height: 40px;
  width: 780px;
  margin: 20px 0;
}
.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}
.footer {
  height: 60px;
  text-align: center;
  font-size: 13px;
  color: #999;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  a {
    font-size: 13px;
    color: #999999;
    text-decoration: none;
  }
}
.footer p {
  line-height: 20px;
}
.animate-box {
  width: 1000px;
  margin: 0 auto;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/appIntroduce.vue